import Cookies from 'js-cookie';
import HttpClient from '../../HttpClient';
import {baseURL} from '../../url';

class Batch extends HttpClient {

    constructor(Callback) {
        // const url = process.env.API_URL;

        super(Callback, {
            baseURL,
            headers: {},
            Callback,
        });
        this.setHeader('Content-Type', 'application/json');
        this.setHeader('Accept', 'application/json');
        this.setBearerAuth(`Bearer  ${Cookies.get('token')}`);

    }

    static request(Callback) {
        return new Batch(Callback);
    }


    getTableApi(api) {
        return this.get(api);
    }

    getBatch() {
        return this.get('batch');
    }


    createBatch(data) {
        return this.post('batch', data);
    }


    getProductionLine() {
        return this.get('batch/production-line');
    }

    batchStatus(address,data) {
        return this.put(address,data);
    }

    productBatch(ProductLineId) {
        return this.get(`Batch/Production-Line/${ProductLineId}`);
    }

    ProductSeriesLine(ProductLineId) {
        return this.get(`ProductSeries/Product-Of-Line/${ProductLineId}`);
    }


    Warning(id) {
        return this.put(`Warning/${id}`);
    }



}

export default Batch;
